
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SharedPushNotificationHelper {
    constructor() { }

    //
    // Compares the current subscription's applicationServerKey to the expected VAPID key.
    // Returns true if they match, false otherwise.
    //
    isSubscriptionKeyValid(subscription: PushSubscription): boolean {
        if (!subscription || !subscription.options || !subscription.options.applicationServerKey) return false;

        const existingKey = subscription.options.applicationServerKey;
        const expectedKey = this.getCurrentVapidPublicKey();

        const keysMatch =
            this.uint8ArrayToBase64(new Uint8Array(existingKey)) ===
            this.uint8ArrayToBase64(expectedKey);

        return keysMatch;
    }

    /**
     * Returns the current VAPID public key from the environment as Uint8Array.
     */
    private getCurrentVapidPublicKey(): Uint8Array {
        const currentVapidPublicKey = environment.pushNotifications.vapidPublicKey;

        const padding = '='.repeat((4 - currentVapidPublicKey.length % 4) % 4);
        const base64 = (currentVapidPublicKey + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = atob(base64);
        return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
    }

    private uint8ArrayToBase64(u8Arr: Uint8Array): string {
        // Convert Uint8Array to base64 string using btoa
        let binary = '';
        for (let i = 0; i < u8Arr.byteLength; i++) {
            binary += String.fromCharCode(u8Arr[i]);
        }
        return btoa(binary);
    }
}